<template>
  <div class="service-hero-wrap" :class="themeClass">
    <!-- Animated Background Elements -->
    <div class="hero-background">
      <div class="gradient-overlay"></div>
      <div class="animated-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>

    <v-container class="hero-container">
      <v-row align="center" justify="center" :class="{ 'flex-row-reverse': reverseLayout }">
        <!-- Content Section -->
        <v-col cols="12" md="6" class="hero-content" data-aos="fade-right" data-aos-duration="800">
          <div class="content-inner">
            <!-- Badge/Category -->
            <div v-if="badge" class="hero-badge" data-aos="fade-down" data-aos-delay="100">
              <v-icon small class="badge-icon">{{ badgeIcon }}</v-icon>
              <span>{{ badge }}</span>
            </div>

            <!-- Title -->
            <h1 class="hero-title" data-aos="fade-up" data-aos-delay="200">
              {{ title }}
            </h1>

            <!-- Description -->
            <p class="hero-description" data-aos="fade-up" data-aos-delay="300">
              {{ description }}
            </p>

            <!-- Tech Stack Badges (if provided) -->
            <div v-if="techStack && techStack.length" class="tech-badges" data-aos="fade-up" data-aos-delay="400">
              <v-chip
                v-for="(tech, index) in techStack"
                :key="index"
                class="tech-chip"
                :color="tech.color || 'primary'"
                outlined
                small
              >
                <v-icon v-if="tech.icon" left small>{{ tech.icon }}</v-icon>
                {{ tech.name }}
              </v-chip>
            </div>

            <!-- Action Buttons -->
            <div class="hero-actions" data-aos="fade-up" data-aos-delay="500">
              <v-btn
                v-if="primaryButton"
                :to="localePath(primaryButton.to)"
                :href="primaryButton.href"
                color="primary"
                x-large
                elevation="8"
                class="primary-btn gradient-btn"
                :class="{ 'pulse-animation': animateButton }"
              >
                <v-icon v-if="primaryButton.icon" left>{{ primaryButton.icon }}</v-icon>
                {{ primaryButton.text }}
              </v-btn>

              <v-btn
                v-if="secondaryButton"
                :to="localePath(secondaryButton.to)"
                :href="secondaryButton.href"
                outlined
                x-large
                color="primary"
                class="secondary-btn ml-3"
              >
                <v-icon v-if="secondaryButton.icon" left>{{ secondaryButton.icon }}</v-icon>
                {{ secondaryButton.text }}
              </v-btn>
            </div>

            <!-- Additional Info/Stats (optional) -->
            <div v-if="stats && stats.length" class="hero-stats" data-aos="fade-up" data-aos-delay="600">
              <div v-for="(stat, index) in stats" :key="index" class="stat-item">
                <div class="stat-value">{{ stat.value }}</div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Image/Illustration Section -->
        <v-col cols="12" md="6" class="hero-image-col" data-aos="fade-left" data-aos-duration="800">
          <div class="hero-image-wrap">
            <!-- Floating Animation Container -->
            <div class="floating-container">
              <img
                v-if="image"
                :src="image"
                :alt="imageAlt || title"
                class="hero-image"
                draggable="false"
              />
              
              <!-- Slot for custom content (like animated mockups) -->
              <slot name="hero-image"></slot>
            </div>

            <!-- Decorative Elements -->
            <div class="decorative-elements">
              <div class="decoration decoration-1"></div>
              <div class="decoration decoration-2"></div>
              <div class="decoration decoration-3"></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ServiceHero',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    },
    badge: {
      type: String,
      default: ''
    },
    badgeIcon: {
      type: String,
      default: 'mdi-star'
    },
    primaryButton: {
      type: Object,
      default: null
      // Format: { text: 'Get Started', to: '/path', icon: 'mdi-rocket', href: '' }
    },
    secondaryButton: {
      type: Object,
      default: null
    },
    techStack: {
      type: Array,
      default: () => []
      // Format: [{ name: 'React Native', icon: 'mdi-react', color: 'cyan' }]
    },
    stats: {
      type: Array,
      default: () => []
      // Format: [{ value: '500+', label: 'Projects' }]
    },
    reverseLayout: {
      type: Boolean,
      default: false
    },
    themeVariant: {
      type: String,
      default: 'default', // 'default', 'gradient', 'minimal'
      validator: (value) => ['default', 'gradient', 'minimal'].includes(value)
    },
    animateButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    themeClass() {
      return `theme-${this.themeVariant}`
    }
  }
}
</script>

<style scoped lang="scss">
@import "./service-hero-style.scss";
</style>


    <!-- <service-hero
      :title="service.title"
      :description="service.body"
      :image="service.img"
      :badge="$t('header.services')"
      badge-icon="mdi-cellphone"
      :primary-button="{
        text: $t('apps.pricingOrder'),
        to: '/services/mobile#contact',
        icon: 'mdi-rocket-launch'
      }"
      :secondary-button="{
        text: $t('landing.watchVideo'),
        href: '#feature',
        icon: 'mdi-play-circle-outline'
      }"
      :tech-stack="[
        { name: 'React Native', icon: 'mdi-react', color: 'cyan' },
        { name: 'iOS', icon: 'mdi-apple-ios', color: 'grey darken-2' },
        { name: 'Android', icon: 'mdi-android', color: 'green' }
      ]"
      :stats="[
        { value: '500+', label: $t('landing.projects') },
        { value: '98%', label: $t('landing.quality') },
        { value: '24/7', label: $t('landing.support') }
      ]"
      theme-variant="default"
    /> -->
